export default __webpack_public_path__ + "images/372b7b706d1ae0ac9d9e904ceee0dcd8.svg";